import React from 'react';
import { PropTypes } from 'prop-types';

import { Input, Form } from 'antd';

const formItemLayout = {
  labelCol: { span: 8 },
  wrapperCol: { span: 12 },
};

const Verify2FAForm = ({ form }) => (
  <Form
    name="basic"
    className="gx-form-row0"
    ref={form}
    {...formItemLayout}
  >
    <span>Enter 6-digit code.</span>
    <Form.Item
      rules={[
        { required: true, message: 'This input is required!' },
      ]}
      name="code"
      label="Code"
    >
      <Input placeholder="XXX XXX" />
    </Form.Item>
  </Form>
);

Verify2FAForm.propTypes = {
  form: PropTypes.shape({
    current: PropTypes.shape({}),
  }),
};

Verify2FAForm.defaultProps = {
  form: {},
};

export default Verify2FAForm;
